import React from "react";
import { useTranslation } from "react-i18next";
import { BsPatchCheck, BsStars, BsHeadset } from 'react-icons/bs'
import { FiArrowRight } from 'react-icons/fi'
import AdVertical from "./VideoAdBlock";

const WhoWeAre = () => {
  const { t } = useTranslation();

  const whoContent = t('homepage.who', { returnObjects: true })

  const trustSignals = [
    { icon: <BsPatchCheck />, text: whoContent?.signals?.[0] },
    { icon: <BsHeadset />, text: whoContent?.signals?.[1] },
    { icon: <BsStars />, text: whoContent?.signals?.[2] }
  ]

  return (
    <section className="px-3 py-10 sm:px-5 sm:py-14">
      <div className="mx-auto max-w-6xl overflow-hidden rounded-[2rem] border border-slate-200 bg-gradient-to-br from-white to-slate-50 shadow-[0_18px_48px_rgba(15,23,42,0.08)]">
        <div className="grid items-stretch lg:grid-cols-[1.05fr_1fr]">
          <div className="relative overflow-hidden border-b border-slate-200 bg-gradient-to-br from-[#f8fbff] via-white to-[#eef6ff] p-6 text-slate-900 sm:p-8 lg:border-b-0 lg:border-r lg:p-10">
            <div className="pointer-events-none absolute -right-24 -top-20 h-56 w-56 rounded-full bg-[#1739bd]/8 blur-3xl" />
            <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-slate-500">{whoContent?.eyebrow}</p>
            <h2 className="mt-2 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">{whoContent?.title}</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">{whoContent?.description}</p>

            <div className="mt-6 grid gap-3">
              {trustSignals.map((item, idx) => (
                <div className="flex items-start gap-2.5 rounded-xl border border-slate-200 bg-white px-3 py-2.5" key={idx}>
                  <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#1739bd]/10 text-[#1739bd]">
                    {item.icon}
                  </span>
                  <span className="text-sm font-semibold text-slate-700">{item.text}</span>
                </div>
              ))}
            </div>

            <button
              className="group mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#092FB6] to-[#636DE5] px-6 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(9,47,182,0.35)] transition hover:brightness-110 sm:text-base"
              onClick={() => (window.location.href = "/about")}
            >
              {whoContent?.cta}
              <FiArrowRight className='transition-transform duration-300 group-hover:translate-x-1' />
            </button>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-blue-50/50 p-4 sm:p-6">
            <AdVertical />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
